import { render, staticRenderFns } from "./staffDetail.vue?vue&type=template&id=65d6f890"
import script from "./staffDetail.vue?vue&type=script&lang=js"
export * from "./staffDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports